import type * as Y from 'yjs';

import { type Revision, RevisionType } from '../types';
import { updateYWithJSON } from '../utils';

export type YRevision = Y.Map<any>;

/**
 * Get the data representing the revision in the Y.Doc.
 */
export function getYRevision(doc: Y.Doc): YRevision {
    return doc.getMap('data');
}

/**
 * Initialize a Yjs document with a revision.
 * This function should be called inside a transaction, otherwise it'll result in N updates.
 */
export function revisionToY(revision: Revision, yRevision: YRevision): YRevision {
    if (yRevision.doc && !yRevision.doc._transaction) {
        throw new Error('revisionToY should be called inside a transaction');
    }

    if (revision.type === RevisionType.Computed) {
        throw new Error('Computed revisions should not be converted to Yjs');
    }

    updateYWithJSON(yRevision, revision);

    return yRevision;
}
